"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_base_1 = __importDefault(require("./api_base"));
exports.default = {
    query: function (siteId) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        return api_base_1.default.get('partnerships/location_data', { params: { site_id: siteId } }).then(function (response) {
            return response.data;
        });
    }
};
//# sourceMappingURL=mindbody_locations_api.js.map